import React, { useState, useEffect } from 'react';

const ModalGestionarNotasContent = ({ onClose }) => {
  const [titulo, setTitulo] = useState('');
  const [descripcion, setDescripcion] = useState('');
  const [notesList, setNotesList] = useState([{ id: 1, titulo: 'GARANTÍA' }]); // Dummy data

  const handleInsertNote = () => {
    if (titulo.trim() === '') {
      alert('Por favor, introduce un título para la nota.');
      return;
    }
    const newNote = { id: Date.now(), titulo: titulo, descripcion: descripcion };
    setNotesList(prevNotes => [...prevNotes, newNote]);
    alert('Insertando nueva nota: ' + titulo);
    setTitulo('');
    setDescripcion('');
  };

  const handleActionBtnClick = (action, noteTitle) => {
    alert(`Acción: ${action} para la nota "${noteTitle}"`);
  };

  return (
    <div className="max-w-2xl mx-auto bg-slate-800 rounded-lg shadow-xl border border-slate-700 flex flex-col">
      <div className="bg-slate-700 p-4 border-b border-slate-600 font-bold text-white relative">
        Gestionar la información de las notas de documento
        <button className="absolute top-4 right-5 bg-transparent border-none text-xl cursor-pointer text-gray-400 hover:text-white" onClick={onClose}>&times;</button>
      </div>
      <div className="p-5 flex-grow overflow-y-auto">
        {/* Sección para dar de alta una nueva nota */}
        <div className="mb-5">
          <div className="font-bold text-blue-400 mb-4 text-base">Dar de alta una nueva nota de documento</div>
          <div className="mb-4">
            <label htmlFor="titulo_nota" className="block mb-1 font-medium text-gray-300">Título</label>
            <input type="text" id="titulo_nota" name="titulo_nota" value={titulo} onChange={(e) => setTitulo(e.target.value)} className="w-full p-2 border border-slate-600 rounded text-sm transition-colors duration-300 focus:outline-none focus:border-blue-500 bg-slate-700 text-gray-300" />
          </div>
          <div className="mb-4">
            <label htmlFor="descripcion_nota" className="block mb-1 font-medium text-gray-300">Descripción</label>
            <textarea id="descripcion_nota" name="descripcion_nota" value={descripcion} onChange={(e) => setDescripcion(e.target.value)} className="w-full p-2 border border-slate-600 rounded text-sm transition-colors duration-300 focus:outline-none focus:border-blue-500 resize-y min-h-[100px] bg-slate-700 text-gray-300"></textarea>
            <div className="text-xs text-gray-400 mt-1">* Los saltos de línea aparecerán también como saltos de línea en la factura o presupuesto.</div>
          </div>
          <div className="flex justify-end mt-4">
            <button onClick={handleInsertNote} className="px-5 py-2.5 border-none rounded cursor-pointer text-sm font-medium bg-blue-600 text-white hover:bg-blue-700">Insertar</button>
          </div>
        </div>

        {/* Sección para el listado de notas */}
        <div className="mb-5">
          <div className="font-bold text-blue-400 mb-4 text-base">Listado de notas de documento</div>
          <div className="mt-5">
            <table className="w-full border-collapse bg-slate-800 rounded shadow-md overflow-hidden">
              <thead>
                <tr>
                  <th className="bg-slate-700 p-3 text-left font-medium text-gray-300 border-b border-slate-600">Listado de notas de documento disponibles</th>
                  <th className="bg-slate-700 p-3 text-left font-medium text-gray-300 border-b border-slate-600"></th>
                </tr>
              </thead>
              <tbody>
                <tr className="bg-slate-700">
                  <td className="p-3 font-bold text-gray-300">Título</td>
                  <td className="p-3 font-bold text-gray-300">Operaciones</td>
                </tr>
                {notesList.map(note => (
                  <tr key={note.id} className="hover:bg-slate-700/50">
                    <td className="p-3 border-b border-slate-700 text-gray-300">{note.titulo}</td>
                    <td className="p-3 border-b border-slate-700 text-gray-300">
                      <div className="flex gap-1.5">
                        <button onClick={() => handleActionBtnClick('Ver', note.titulo)} className="p-1 border-none bg-transparent cursor-pointer text-base text-gray-400 hover:text-blue-400" title="Ver">️</button>
                        <button onClick={() => handleActionBtnClick('Editar', note.titulo)} className="p-1 border-none bg-transparent cursor-pointer text-base text-gray-400 hover:text-blue-400" title="Editar">✏️</button>
                        <button onClick={() => handleActionBtnClick('Eliminar', note.titulo)} className="p-1 border-none bg-transparent cursor-pointer text-base text-gray-400 hover:text-blue-400" title="Eliminar">️</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="mt-4 text-sm text-gray-400">
              Mostrando página {Math.ceil(notesList.length / 1)} de {Math.ceil(notesList.length / 1)} ({notesList.length} elementos en total)
            </div>
          </div>
        </div>

        {/* Acciones del formulario */}
        <div className="flex gap-2.5 justify-end mt-5 pt-5 border-t border-slate-700">
          <button className="px-5 py-2.5 border-none rounded cursor-pointer text-sm font-medium bg-gray-600 text-white hover:bg-gray-700" onClick={onClose}>Cerrar</button>
        </div>
      </div>
    </div>
  );
};

export default ModalGestionarNotasContent;